import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { BackService } from '../../services/back.service';
@Component({
    selector: 'bp-end-flow',
    templateUrl: './bp-end-flow.component.html',
    styleUrls: ['./bp-end-flow.component.scss'],
    animations: fuseAnimations,
    host: {
        class: 'h-screen w-screen flex flex-col items-center justify-center',
    },
    imports: [MatProgressBarModule, MatIconModule]
})
export class BpEndFlowComponent implements OnInit {
  progress = 0;
  @Input() duration = 2000;
  @Input() icon = 'heroicons_outline:check-circle';
  @Input() redirectUrl: string | undefined;
  @Input() hideAppBar = true;
  @Input() showProgress = true;
  @Input() showIcon = true;
  intervalId: any;

  constructor(
    private backService: BackService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.backService.updateNoHeader(this.hideAppBar);
    }, 0);
    // this.intervalId = setInterval(() => this.animateProgress(), this.duration / 100);

    if (this.redirectUrl != undefined) {
      setTimeout(() => {
        this.router.navigateByUrl(this.redirectUrl!);
      }, this.duration);
    }
  }

  animateProgress() {
    // Increment the progress by 1
    this.progress += 1;

    // If the progress reaches 100, clear the interval
    if (this.progress >= 100) {
      this.progress = 100;
      clearInterval(this.intervalId);
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
